import React from "react";

type MJLogoProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
};

const MJLogo = ({ size = 40, ...rest }: MJLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    stroke="currentColor"
    fill="none"
    viewBox="0 0 1024 1024"
    {...rest}
  >
    <title>{"MJ Logo"}</title>
    <g strokeMiterlimit="100">
      <path
        fillRule="evenodd"
        strokeWidth="50"
        d="m505.6 53.3 401.2 231.6v463.3L505.6 979.8 104.4 748.2V284.9z"
      />
      <path
        fillRule="evenodd"
        strokeWidth="50"
        d="M505.4 209.2 773 363.6v308.9L505.4 827 237.9 672.5V363.6z"
      />
      <path fillRule="evenodd" strokeWidth="45" d="m770.8 425.7 2.2 246.8-149.7 86.7-.4-256.8z" />
      <path fillRule="evenodd" strokeWidth="45" d="m390.3 501.9-.4 259.7-151.1-88.1 1.3-251.3z" />
      <path
        fillRule="evenodd"
        strokeWidth="45"
        d="m505.4 563.8 268.1-149.6-.5 258.3L505.4 827 237.9 672.5l.7-252.7z"
      />
      <path
        fillRule="evenodd"
        strokeWidth="45"
        d="m510.9 404.2 162-97.1L773 363.6v308.9L505.4 827 237.9 672.5V363.6l108.8-61.5z"
      />
    </g>
  </svg>
);

export default MJLogo;
